import React from "react";
import Footer from "./Footer";

function Creation() {
    
    return (
        <div className="bg-no-repeat bg-cover bg-center">
          <div className="max-w-4xl mx-auto bg-white overflow-hidden">
            <header className="py-4 px-6">
            <h1 className="text-5xl font-semibold tracking-tight text-balance text-gray-900 sm:text-7xl">How to Create a Game Name</h1>
            </header>
            <div className="p-6 space-y-6">
            <img className="h-auto max-w-lg rounded-lg" src="../images/controller.jpg" alt="image description"></img>
              <section>
                <h2 className="text-2xl text-left font-semibold text-gray-800">
                  1. Understand Your Game
                </h2>
                <p className="text-gray-600 mt-2">
                  Start by defining key aspects of your game, such as:
                </p>
                <ul className="list-disc list-inside text-gray-600 mt-2">
                  <li><strong>Genre:</strong> Fantasy, sci-fi, puzzle, etc.</li>
                  <li><strong>Theme:</strong> Dark, whimsical, action-packed, etc.</li>
                  <li><strong>Setting:</strong> Space, mythical lands, modern city.</li>
                  <li><strong>Target Audience:</strong> Hardcore gamers, casual players, or kids.</li>
                </ul>
              </section>
    
              <section>
                <h2 className="text-2xl text-left font-semibold text-gray-800">
                  2. Brainstorm Keywords
                </h2>
                <p className="text-gray-600 mt-2">
                  Create a list of words related to your game:
                </p>
                <ul className="list-disc list-inside text-gray-600 mt-2">
                  <li><strong>Core Elements:</strong> Quest, Battle, Forge.</li>
                  <li><strong>Imagery:</strong> Shadow, Light, Storm.</li>
                  <li><strong>Emotion:</strong> Fury, Mystery, Chaos.</li>
                  <li><strong>Unique Terms:</strong> Invented words like Zyra or Vexus.</li>
                </ul>
              </section>
    
              <section>
                <h2 className="text-2xl text-left font-semibold text-gray-800">
                  3. Combine and Experiment
                </h2>
                <p className="text-gray-600 mt-2">Mix and match keywords to form unique names:</p>
                <ul className="list-disc list-inside text-gray-600 mt-2">
                  <li><strong>Compound Words:</strong> ShadowForge, StarClash.</li>
                  <li><strong>Modifiers:</strong> NeoGenesis, HyperDrift.</li>
                  <li><strong>Acronyms:</strong> COD (Call of Duty).</li>
                  <li><strong>Play on Words:</strong> Knightmare (knight + nightmare).</li>
                </ul>
              </section>
    
              <section>
                <h2 className="text-2xl text-left font-semibold text-gray-800">
                  4. Check Availability
                </h2>
                <p className="text-gray-600 mt-2">
                  Ensure your chosen name is unique:
                </p>
                <ul className="list-disc list-inside text-gray-600 mt-2">
                  <li>Check domain availability (e.g., localhost).</li>
                  <li>Verify social media handles.</li>
                  <li>Search for existing trademarks or similar game names.</li>
                </ul>
              </section>
    
              <section>
                <h2 className="text-2xl text-left font-semibold text-gray-800">
                  5. Test for Impact
                </h2>
                <p className="text-gray-600 mt-2">
                  Evaluate your name by asking:
                </p>
                <ul className="list-disc list-inside text-gray-600 mt-2">
                  <li>Is it memorable?</li>
                  <li>Is it pronounceable?</li>
                  <li>Does it fit the game?</li>
                  <li>Does it stand out?</li>
                </ul>
              </section>
            </div>
          </div>
        </div>
      );
}

export default Creation;